/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "react-query";
import axios from "axios";
import { useEffect, useState } from "react";
import "./home.scss";
import { BrandButton } from "../components/form/buttons";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../components/loader";
import LoadError from "../components/error";
import { ApiEndpoint, imagesUrl } from "../components/utils";
import { pageIds } from "../components/utils";
import homeCalloutImg1 from "../assets/home_callout_1.svg";
import homeCalloutImg2 from "../assets/home_callout_2.svg";
import homeCalloutImg3 from "../assets/home_callout_3.svg";
import homeFPO from "../assets/screenshot.png";
import { setAppInfo, userLoggedIn } from "../components/user";

interface PageResponse {
  headerTitle?: string;
  welcomeMessage?: any;
  standardHeadline?: string;
  extendedHeadline?: string;
  standardDescription?: any;
  extendedDescription?: any;
  footerDescription?: any;
}

const Home = () => {
  const [data, setdata] = useState<PageResponse | null>();
  const navigate = useNavigate();
  const [queryParameters] = useSearchParams();


  const { isLoading, error } = useQuery("welecomePageData", async () => {
    const resp = await axios.get(
      ApiEndpoint +
        "wp-json/satapp-api/v1/getPageText?slug=" +
        pageIds.homepage
    );
    setdata(resp.data as PageResponse);
  });

  /*
   * check for local storage and see if the user is logged in...
   * if they are, just get them to the dashboard
   */
  useEffect(() => {
    if(userLoggedIn()) navigate('/dashboard');

    const code = queryParameters.get("couponID");
    if (code){
      setAppInfo({couponCode: code});
    } 
  }, []);

  if (isLoading)
    return <Loader />;
  if (error) return <LoadError />;
  return (
    <div className="homePage">
      <div className="pageHeader">
        <h1>{data?.headerTitle}</h1>
      </div>

      <div className="embedCallout">
        <div className="leftColumn">
          <img src={`${imagesUrl}${homeFPO}`} />
        </div>
        <div className="rightColumn">
          <div className="item">
            <div className="iconHolder">
              <img src={`${imagesUrl}${homeCalloutImg1}`} />
            </div>
            <div className="contentHolder">
              <p>
                <strong>View your progress</strong>
              </p>
              <p>See how many tests you’ve completed, how many you still have left to take, and where you are on the tests you’ve started.</p>
            </div>
          </div>
          <div className="item">
            <div className="iconHolder">
              <img src={`${imagesUrl}${homeCalloutImg2}`} />
            </div>
            <div className="contentHolder">
              <p>
                <strong>Start and stop when you want</strong>
              </p>
              <p>Can’t finish your test at the moment?  No problem – pause your test and come back to it later.</p>
            </div>
          </div>
          <div className="item">
            <div className="iconHolder">
              <img src={`${imagesUrl}${homeCalloutImg3}`} />
            </div>
            <div className="contentHolder">
              <p>
                <strong>Check your results</strong>
              </p>
              <p>View your scores and detailed reports of your performance on each of the most commonly-tested skills.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="cta">
        <div className="col1">
          <h4>TWO WAYS TO PAY:</h4>
          <div className="calloutHolder">
            <div className="item">
              <div className="numberHolder">1</div>
              <div className="calloutText">
                <h5>ONE-TIME PAYMENT</h5>
                <p>Access to all of our proprietary SAT Practice Tests.</p>
                <BrandButton onClick={() => navigate("register")}>
                  START NOW &gt;
                </BrandButton>
              </div>
            </div>
            <div className="item">
              <div className="numberHolder alt">2</div>
              <div className="calloutText">
                <h5>PAY AS YOU GO</h5>
                <p>A-la-carte access to our SAT Practice Tests.</p>
                <BrandButton onClick={() => navigate("register_payg")}>
                  START NOW &gt;
                </BrandButton>
              </div>
            </div>
          </div>
        </div>
        <div className="col2">
          <div className="loginHolder">
            <p>Already have an account?</p>
            <p>
              <BrandButton onClick={() => navigate("login")}>
                LOGIN &gt;
              </BrandButton>
            </p>
          </div>
        </div>
      </div>

      <div className="pageContent">
        <div dangerouslySetInnerHTML={{ __html: data?.welcomeMessage }} />
        <div
          className="homeFooter"
          dangerouslySetInnerHTML={{ __html: data?.footerDescription }}
        />
      </div>
    </div>
  );
};

export default Home;
